import { render, staticRenderFns } from "./BarCreation.vue?vue&type=template&id=51a382f5&scoped=true"
import script from "./BarCreation.vue?vue&type=script&lang=js"
export * from "./BarCreation.vue?vue&type=script&lang=js"
import style0 from "./BarCreation.vue?vue&type=style&index=0&id=51a382f5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a382f5",
  null
  
)

export default component.exports